/** @format */

import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";

@Pipe({
  name: "transportText"
})
export class TransportTextPipe implements PipeTransform {
  transform(commute: { login: NsEmpWebExpData.ICommuteOption; logout: NsEmpWebExpData.ICommuteOption } | undefined): string {
    const notSelected = "";
    if (commute?.login || commute?.logout) {
      if (commute.login && commute.login.id === "parking") {
        const value = commute.login?.value as NsEmpWebExpData.IParkingPremise;
        let parkingText = `Parking: ${value?.premise} `;
        if (value?.seatId) {
          parkingText += `Slot: ${value?.seatName}`;
        }
        return parkingText;
      } else {
        const res = [];
        if (commute.login && commute.login.id === "transport") {
          res.push("Check-In: Cab");
        }
        if (commute.logout && commute.logout.id === "transport") {
          res.push("Check-Out: Cab");
        }
        return (res.length && res.join(", ")) || notSelected;
      }
    }
    return notSelected;
  }
}
